import { useEffect, useRef } from 'react';

const useIntervalHandler = (callback: any, delay: any) => {
  // React 19 requires an explicit initial value here.
  const savedCallback: any = useRef(null);

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      if (savedCallback != null) {
        savedCallback.current();
      }
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

export default useIntervalHandler;
